// core/data/messages.ts — Typed seed for conversations/messages.
//
// Faithful port of legacy src/scripts/data/messages.js.
// Conversations include DMs and groups, each with an embedded messages array.

import type { Conversation } from '@/core/models/message';

export const seedConversations: Conversation[] = [
  {
    id: 'c-01', type: 'dm', name: 'LeoWithSara', av: 'av-2', online: true, time: '2m', unread: 2,
    messages: [
      { id: 'm1', fromMe: false, body: 'Hey! Did you catch the WayneTech announcement?', time: '10:02' },
      { id: 'm2', fromMe: true,  body: 'Just did. Decentralization done right.', time: '10:04' },
      { id: 'm3', fromMe: false, body: 'Right? The open-web angle is exactly what we needed.', time: '10:05' },
      { id: 'm4', fromMe: false, body: 'Sending the recap now.', time: '10:05' },
      { id: 'm5', fromMe: false, media: 'image', body: '', time: '10:06' },
    ],
  },
  {
    id: 'c-02', type: 'dm', name: 'TechVisionary', av: 'av-4', online: false, time: '18m', unread: 0,
    messages: [
      { id: 'm1', fromMe: false, body: 'Loved your take on edge compute.', time: '09:40' },
      { id: 'm2', fromMe: true,  body: 'Thanks! Still refining the argument.', time: '09:48' },
      { id: 'm3', fromMe: false, media: 'voice', body: '0:42', time: '09:50' },
    ],
  },
  {
    id: 'c-03', type: 'group', name: 'Open Minds', av: 'av-3', members: 8, time: '1h', unread: 0,
    messages: [
      { id: 'm1', fromMe: false, author: 'FreeThinker',  body: 'Welcome to the group, everyone!', time: '09:10' },
      { id: 'm2', fromMe: false, author: 'OpenMind',     body: 'Glad to be here.', time: '09:12' },
      { id: 'm3', fromMe: true,  body: 'Excited to build with you all.', time: '09:15' },
      { id: 'm4', fromMe: false, author: 'LibertyVoice', body: "Let's keep it civil and curious.", time: '09:20' },
    ],
  },
  {
    id: 'c-04', type: 'dm', name: 'OpenMind', av: 'av-3', online: true, time: '2h', unread: 0,
    messages: [
      { id: 'm1', fromMe: true,  body: 'Did you see the new Explore page?', time: '08:30' },
      { id: 'm2', fromMe: false, body: 'Yes, the discovery feed is slick.', time: '08:33' },
    ],
  },
  {
    id: 'c-05', type: 'group', name: 'Freedom Builders', av: 'av-1', members: 24, time: '3h', unread: 5,
    messages: [
      { id: 'm1', fromMe: false, author: 'FreedomSeeker', body: 'Shipping the v2 spec today.', time: '07:10' },
      { id: 'm2', fromMe: false, author: 'WayneTech',     body: 'Reviewed, looks strong.', time: '07:25' },
      { id: 'm3', fromMe: false, author: 'CryptoChad',    body: 'Adding the payout flow notes.', time: '07:40' },
    ],
  },
  {
    id: 'c-06', type: 'dm', name: 'CryptoChad', av: 'av-5', online: false, time: '5h', unread: 0,
    messages: [
      { id: 'm1', fromMe: false, body: 'Wallet integration is live on staging.', time: 'Yesterday' },
      { id: 'm2', fromMe: true,  body: 'Testing now. Looks clean.', time: 'Yesterday' },
    ],
  },
  {
    id: 'c-07', type: 'dm', name: 'VisionaryLex', av: 'av-2', online: false, time: '1d', unread: 0,
    messages: [
      { id: 'm1', fromMe: false, body: 'Coffee next week?', time: 'Mon' },
      { id: 'm2', fromMe: true,  body: 'For sure, Thursday works.', time: 'Mon' },
    ],
  },
  {
    id: 'c-08', type: 'group', name: 'Privacy Circle', av: 'av-4', members: 12, time: '2d', unread: 0,
    messages: [
      { id: 'm1', fromMe: false, author: 'SeenAndUnseen', body: 'New privacy toolkit drafted.', time: 'Sat' },
      { id: 'm2', fromMe: true,  body: 'Great, I will review tonight.', time: 'Sat' },
      { id: 'm3', fromMe: false, author: 'LibertyMind',   body: 'Decentralized by default, please.', time: 'Sun' },
    ],
  },
  {
    id: 'c-09', type: 'dm', name: 'SteelDylan', av: 'av-1', online: true, time: '3d', unread: 0,
    messages: [
      { id: 'm1', fromMe: false, body: 'Welcome aboard!', time: 'Thu' },
      { id: 'm2', fromMe: true,  body: 'Thanks, happy to be here.', time: 'Thu' },
    ],
  },
];
